import React from 'react';
import { ArrowDownLeft, ArrowUpRight, History } from 'lucide-react';

const WalletTabSwitcher = ({
  activeTab,
  onTabChange,
  t,
  isMobile = false
}) => {
  const tabs = [
    { id: 'deposit', label: t('deposit'), icon: ArrowDownLeft, color: '#0ecb81' },
    { id: 'withdraw', label: t('withdraw'), icon: ArrowUpRight, color: '#f6465d' },
    { id: 'history', label: t('depositHistory'), icon: History, color: '#f0b90b' },
  ];

  if (isMobile) {
    return (
      <div style={{
        display: 'flex',
        backgroundColor: '#1e2329',
        borderRadius: '12px',
        padding: '4px',
        marginBottom: '16px',
      }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              flex: 1,
              padding: '10px 8px',
              backgroundColor: activeTab === tab.id ? '#2b3139' : 'transparent',
              color: activeTab === tab.id ? '#eaecef' : '#848e9c',
              border: 'none',
              borderRadius: '10px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
            }}
          >
            <tab.icon size={16} color={activeTab === tab.id ? tab.color : '#848e9c'} />
            {tab.label}
          </button>
        ))}
      </div>
    );
  }

  // Desktop version
  return (
    <div style={{
      display: 'flex',
      gap: '8px',
      borderBottom: '1px solid #2b3139',
      marginBottom: '24px',
    }}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          style={{
            padding: '12px 24px',
            backgroundColor: 'transparent',
            border: 'none',
            borderBottom: `2px solid ${activeTab === tab.id ? '#f0b90b' : 'transparent'}`,
            color: activeTab === tab.id ? '#f0b90b' : '#848e9c',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <tab.icon size={16} />
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default WalletTabSwitcher;
